import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  feature: string;
  basic: boolean | string;
  standard: boolean | string;
  premium: boolean | string;
}

interface ComparisonTableProps {
  features: ComparisonFeature[];
}

export default function ComparisonTable({ features }: ComparisonTableProps) {
  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="CheckIcon" size={24} className="text-success mx-auto" />
      ) : (
        <Icon name="XMarkIcon" size={24} className="text-muted-foreground mx-auto" />
      );
    }
    return <span className="text-foreground font-medium">{value}</span>;
  };

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-4 text-center">
            Compare Treatment Options
          </h2>
          <p className="text-lg text-muted-foreground mb-12 text-center max-w-2xl mx-auto">
            Choose the subscription plan that best fits your healthcare needs and budget
          </p>

          <div className="bg-card border border-border rounded-xl overflow-hidden shadow-elevation-lg">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-muted/50 border-b border-border">
                    <th className="text-left p-6 font-heading font-semibold text-foreground">
                      Features
                    </th>
                    <th className="text-center p-6 font-heading font-semibold text-foreground">
                      1 Month
                    </th>
                    <th className="text-center p-6 font-heading font-semibold text-foreground">
                      <div className="flex flex-col items-center gap-2">
                        <span>3 Months</span>
                        <span className="px-2 py-1 bg-accent text-accent-foreground text-xs rounded-full">
                          Popular
                        </span>
                      </div>
                    </th>
                    <th className="text-center p-6 font-heading font-semibold text-foreground">
                      6 Months
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {features.map((feature, index) => (
                    <tr
                      key={index}
                      className={`border-b border-border ${
                        index % 2 === 0 ? 'bg-background' : 'bg-muted/20'
                      }`}
                    >
                      <td className="p-6 text-foreground font-medium">{feature.feature}</td>
                      <td className="p-6 text-center">{renderValue(feature.basic)}</td>
                      <td className="p-6 text-center bg-primary/5">
                        {renderValue(feature.standard)}
                      </td>
                      <td className="p-6 text-center">{renderValue(feature.premium)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}